import { useLocation, Link } from 'react-router-dom';
import React, { useEffect, useState , useRef } from 'react';
import logostarcastnews from '../assets/logoMXR.png';
import DefaultAvatar from '../assets/defaultAvatar.png';
import Modal from 'react-modal';
import '../pages/animNoti.css'; // นำเข้า CSS ที่สร้างขึ้น

import { getAllNotification } from '../services/userApi';

const Topbar = () => {
    const location = useLocation();
    const [user, setUser] = useState(null);

    const [showTooltip, setShowTooltip] = useState(false);
    const textRef = useRef(null);
    const [isNotification, setIsNotification] = useState(false);
    const [notiData, setNotiData] = useState([]);
    const [modalNotiIsOpen, setModalNotiIsOpen] = useState(false);
    const [isUpdatedNoti, setIsUpdatedNoti] = useState(false);
    const userData = JSON.parse(localStorage.getItem('account') || sessionStorage.getItem('account'));

    useEffect(() => {
        // noti
        const isNoti = parseInt(sessionStorage.getItem('notification'));
        setIsNotification(isNoti === 1);  
        
        fetchUserData();
    }, [location.pathname,isUpdatedNoti]);  // ใช้ isUpdatedNoti เป็น dependency

    // ฟังก์ชันสำหรับจัดการเมื่อ hover
    const handleMouseEnter = () => {
        setShowTooltip(true);
    };

    // ฟังก์ชันสำหรับจัดการเมื่อออกจาก hover
    const handleMouseLeave = () => {
        setShowTooltip(false);
    };
    
    const fetchUserData = async () => {
        try {
           
            if (userData) {
                setUser(userData);
            }
        } catch (error) {
            console.error('Failed to fetch user data:', error);
        }
    };

    // ถ้า path เป็น "/" จะไม่แสดง Topbar
    if (location.pathname === '/') {
        return null;
    }

    const navLinks = [
        { to: '/main', label: 'หน้าหลัก' },
        { to: '/complete-couse', label: 'หลักสูตรที่จบแล้ว' },
        { to: '/dowload-files', label: 'ดาวน์โหลดเอกสาร' },
        { to: '/community-comment', label: 'สอบ-ถามรวม' },
    ];

    const getAllNotificationApi = async () => {
        try {
            const result = await getAllNotification();     
            if (result.status === true) {
                setNotiData(result.data?.notifications);
                //setExpandedCreateNoti(false);
                setModalNotiIsOpen(true);
            } else {
                throw new Error("Cannot get all notification. Please try again");
            };
        } catch (error) {            
            await console.error("Get all notification error",error?.response);
        };
    };  

    

    const onToggleNotification = async (e) => {
        e.preventDefault();
    
        if (modalNotiIsOpen) {
            setModalNotiIsOpen(false); // ปิด Modal หากเปิดอยู่
        } else {
            setIsUpdatedNoti(false); // รีเซ็ตก่อน
            setModalNotiIsOpen(true); // เปิด Modal
            await getAllNotificationApi(); // ดึงข้อมูล
            setIsUpdatedNoti(true); // อัปเดตสถานะหลังดึงข้อมูล
        }
    };
      

    const styles = {
        navbarLinks: {
            display: 'flex',
            //gap: '20px',        
            alignItems: 'center',
            justifyContent: 'center',        
        },
        circleButton: {
          
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            backgroundColor: 'white',//'#455a64',
            border: '2px solid #455a64',
            color: '#455a64',
            fontSize: '20px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 'bold',
            position:'relative'
        },   
        modalContent: {
            maxHeight: '60vh',
            overflowY: 'auto',
            paddingRight: '20px', // เพิ่ม padding ด้านขวาเพื่อเลื่อน scrollbar
            width:'100%'
        },
        panel: {
            backgroundColor: 'rgba(230,230,230,1)',
            border: '1px solid #ccc',
            borderRadius: '20px',
            //marginBottom: '20px',
            marginTop: '10px',
            padding: '20px',
            //boxShadow: '0 2px 4px rgba(0,0,0,1)',
        },
        panelLine: {
            border: '1px solid #777',
            //width: '50%',
            margin: '10px auto',
        },      
    
    }

    const notiStyles = {
        overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.0)', // สีพื้นหลังด้านนอก Modal (backdrop)
        },        
        content: {
            top: '11%',
            left: 'auto',
            right: '2%',
            bottom: 'auto',
            //transform: 'translate(-50%, -50%)',
            padding: '20px',
            backgroundColor: 'rgba(255, 255, 255, 1.0)',
            borderRadius: '20px',
            fontFamily: 'Kanit, sans-serif', // ใช้ฟอนต์ Roboto
            position: 'absolute',
    
            border: '1px solid #ccc',
            boxShadow: '0 2px 4px rgba(0,0,0,1.0)',
            width: '500px',           
            zIndex: '1000',
        },
    };
    

    return (
        <header>
            <nav
                style={{
                    position: 'fixed',
                    top: 0,
                    width: '100%',
                    height: '90px',
                    background: 'linear-gradient(90deg, #7C93B7 0%, #374151 100%)',
                    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.5)',
                    zIndex: 1000,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '4px 92px',
                    boxSizing: 'border-box',
                    whiteSpace: 'nowrap',
                }}
            >
                {/* Center Content */}
                <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '91px' }}>
                        <img
                            src={logostarcastnews}
                            alt="logostartcast"
                            style={{
                                height: '100%', /*61px*/
                            }}
                        />
                        {navLinks.map((link) => (
                            <Link
                                key={link.to}
                                to={link.to}
                                style={{
                                    color: location.pathname === link.to ? 'white' : '#F9FAFB',
                                    fontWeight: location.pathname === link.to ? 'bold' : 'normal',
                                    fontSize: '1vw',
                                    textDecoration: 'none',
                                }}
                            >
                                {link.label}
                            </Link>
                        ))}
                    </div>
                </div>
                <div style={styles.navbarLinks}>
                    <button style={{...styles.circleButton,marginRight:'20px'}} onClick={(e) => onToggleNotification(e)}
                    >
                        <i className="fa-solid fa-bell" style={{}}></i>
                        {isNotification && (
                            <div className="notificationBadge">
                                {/* ใส่จำนวน Noti เช่น 3 หรือปล่อยว่าง */}
                                {/* 3 */}
                            </div>
                        )}                        
                    </button>                            
                    <Link
                        to="/Profile"
                        style={{
                            color: '#394454',
                            fontSize: '1vw',
                            textDecoration: 'none',
                            background: 'white',
                            borderRadius: '8px',
                            padding: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            maxWidth: '300px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',

                            zIndex: 10, // เพิ่ม zIndex ให้กับ Link เพื่อให้แน่ใจว่าอยู่ด้านหน้า
                        }}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    >
                        {user ? (
                            <>
                                <img
                                    src={user.image_url ? user.image_url : DefaultAvatar}
                                    alt="Profile"
                                    style={{
                                        width: '2vw',
                                        height: '2vw',
                                        borderRadius: '50%',
                                        marginRight: '10px',
                                    }}
                                />
                                <span
                                    style={{
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        maxWidth: '200px',
                                        display: 'inline-block',
                                        zIndex: 10, // เพิ่ม zIndex ให้กับ span
                                    }}
                                >
                                    {user.first_name} {user.last_name}
                                    {showTooltip && (
                                        <span 
                                            style={{
                                                position: 'absolute', 
                                                top: '110%',  
                                                right: '4%',  // ชิดขอบขวา
                                                backgroundColor: 'rgba(57,60,62,0.8)', 
                                                color: 'white', 
                                                padding: '5px 10px',
                                                borderRadius: '5px',
                                                fontSize: '14px',
                                                whiteSpace: 'nowrap',
                                                boxShadow: '0px 0px 5px rgba(0,0,0,0.3)', // เพิ่มเงาเพื่อให้ดูชัดเจนขึ้น
                                                zIndex: 0, // เพิ่ม zIndex ให้ tooltip อยู่ด้านหน้า
                                            }}
                                        >
                                            {user.first_name} {user.last_name}
                                        </span>
                                    )}
                                </span>
                            </>
                        ) : (
                            'โปรไฟล์'
                        )}
                    </Link>
                </div>
            </nav>
            {/* modal noti */}
            <Modal
                isOpen={modalNotiIsOpen}
                style={notiStyles}
                onRequestClose={() => setModalNotiIsOpen(false)}
            >
                <div style={styles.modalHeader}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',                            
                    }}>
                    <span style={{display: 'block', textAlign: 'left',color:'#44526e',fontSize:'30px',fontWeight:'bold'}}>การแจ้งเตือน</span>
                    </div>
                    <hr style={styles.panelLine}></hr>
                    <div style={{...styles.modalContent,maxHeight: '70vh'}}>
                    {notiData.map(item => (
                        <div key={item.uid} style={{...styles.panel,padding:'10px'}}>

                            <div style={{ display: 'flex', alignItems: '',justifyContent:'space-between' }}>
                                <img 
                                    src={(item.image_url || DefaultAvatar)}                                     
                                    style={{width: '50px',height: '50px',borderRadius: '50%',marginRight: '0px',flexShrink: 0,}} 
                                /> 
                                <div style={{ display: 'flex', flexDirection: 'column',marginLeft:'0px',width: '85%' }}>                                    
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',      
                                                                                          
                                    }}>
                                        <span style={{ whiteSpace: 'nowrap',fontSize:'18px',color:'#8b8b8b' }}>{item.first_name || '-'}&nbsp;&nbsp;{item.last_name || '-'}</span>                                  
                                    </div>  
                                    <span style={{ display: 'block', textAlign: 'left',wordWrap: 'break-word',whiteSpace:'normal',fontSize: '16px',color:'#44526e',fontWeight:'bold' }}>{item.name || '-'}</span>
                                    <span style={{ display: 'block', textAlign: 'left',wordWrap: 'break-word',whiteSpace:'normal',fontSize: '16px' }}>{item.description || '-'}</span>
                                </div>
                            </div>

                        </div>
                    ))}       
                    </div>      
                </div>
            </Modal>                          
        </header>
    );
};

export default Topbar;
